export const ACCESS_TOKEN_EXPIRED_DETAIL = '[401] Access token expired';
export const SESSION_TOKEN_EXPIRED_DETAIL = '[401] Session token expired';
export const INVALID_ACCESS_TOKEN_DETAIL = '[401] Invalid access token';
export const INVALID_SESSION_TOKEN_DETAIL = '[401] Invalid session token';

// HTTP timeout configuration
export const DEFAULT_HTTP_TIMEOUT_MS = 30000; // 30 seconds
